module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_diamond__v.76f2cfb3.png";